import { Plus } from "lucide-react";
import { clienteName, eur, fmtDate, km } from "../lib/format";
import { ReclamoBadge } from "./Badges";
import { Button } from "./ui/button";

const Info = ({ label, children, testId }) => (
  <div><div className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{label}</div><div className="mt-0.5 text-sm font-medium" data-testid={testId}>{children || "—"}</div></div>
);

const Card = ({ title, children }) => (
  <section className="rise rounded-md border bg-white p-5">
    <h2 className="mb-4 font-display text-lg font-bold">{title}</h2>
    {children}
  </section>
);

export const ClienteCard = ({ c, contatti, indirizzo }) => (
  <Card title="Cliente">
    <div className="grid gap-3">
      <Info label="Nome" testId="detail-cliente">{clienteName(c)}</Info>
      <Info label="CF / P.IVA"><span className="font-mono">{c.codice_fiscale || c.partita_iva}</span></Info>
      <Info label="Contatti">{contatti}</Info>
      <Info label="Indirizzo">{indirizzo}</Info>
    </div>
  </Card>
);

export const VeicoloCard = ({ v, kmInizio }) => (
  <Card title="Veicolo">
    <div className="grid grid-cols-2 gap-3">
      <Info label="Marca / Modello">{v.marca} {v.modello}</Info>
      <Info label="Versione">{v.versione}</Info>
      <Info label="Telaio"><span className="font-mono text-xs">{v.telaio}</span></Info>
      <Info label="Immatricolazione">{fmtDate(v.data_immatricolazione)}</Info>
      <Info label="Km alla consegna">{km(kmInizio)}</Info>
      <Info label="Alimentazione">{v.alimentazione}</Info>
    </div>
  </Card>
);

export const CoperturaCard = ({ g }) => (
  <Card title="Copertura">
    <div className="grid grid-cols-2 gap-3">
      <Info label="Durata">{g.durata_mesi} mesi</Info>
      <Info label="Limite km">{g.km_limite ? km(g.km_limite) : "Illimitati"}</Info>
      {g.tipo === "commerciale" && <><Info label="Massimale">{eur(g.massimale)}</Info><Info label="Franchigia">{eur(g.franchigia)}</Info><Info label="Prezzo">{eur(g.prezzo)}</Info></>}
      <Info label="Registrata da">{g.created_by}</Info>
    </div>
    <div className="mt-4 flex flex-wrap gap-1">{g.componenti.map((x) => <span key={x} className="rounded-sm bg-slate-100 px-2 py-0.5 text-xs">{x}</span>)}</div>
    {g.note && <p className="mt-3 text-sm text-muted-foreground">{g.note}</p>}
  </Card>
);

const ReclamoRow = ({ r, onOpen }) => (
  <button onClick={() => onOpen(r)} data-testid={`reclamo-row-${r.id}`}
    className="flex w-full flex-wrap items-center gap-3 border-b px-5 py-3 text-left last:border-0 hover:bg-slate-50">
    <span className="font-mono text-xs font-bold">{r.numero}</span>
    <span className="text-sm font-semibold">{r.componente}</span>
    <span className="min-w-0 flex-1 truncate text-sm text-muted-foreground">{r.descrizione}</span>
    <span className="text-xs">{fmtDate(r.data_apertura)}</span>
    <span className="w-24 text-right text-sm font-semibold">{eur(r.costo_ricambi + r.costo_manodopera)}</span>
    <ReclamoBadge stato={r.stato} />
  </button>
);

export const ReclamiSection = ({ reclami, totale, onNew, onOpen }) => (
  <section className="rise mt-6 rounded-md border bg-white" data-testid="reclami-section">
    <div className="flex flex-wrap items-center justify-between gap-2 border-b px-5 py-4">
      <div><h2 className="font-display text-lg font-bold">Reclami & interventi</h2><div className="text-xs text-muted-foreground">Costo interventi approvati/chiusi: <b>{eur(totale)}</b></div></div>
      <Button size="sm" onClick={onNew} className="bg-[#B08D57] hover:bg-[#96764A]" data-testid="new-reclamo-btn"><Plus className="mr-1 h-4 w-4" /> Apri reclamo</Button>
    </div>
    {reclami.length === 0
      ? <div className="px-5 py-10 text-center text-sm text-muted-foreground">Nessun reclamo registrato su questa garanzia.</div>
      : reclami.map((r) => <ReclamoRow key={r.id} r={r} onOpen={onOpen} />)}
  </section>
);
